import { Component, computed, input } from '@angular/core';

export type AvatarSize = 'sm' | 'md' | 'lg';
export type AvatarTone = 'blue' | 'gray';

/** Initials from a display name: "Ole Petter Dahlmann" → "OD" (design `initials()`). */
export function initialsOf(name: string | null | undefined): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length > 1) return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  return (words[0] ?? '').slice(0, 2).toUpperCase();
}

@Component({
  selector: 'mbm-avatar',
  template: `<span class="mbm-avatar mbm-avatar-{{ size() }} mbm-avatar-{{ tone() }}" aria-hidden="true">{{ initials() }}</span>`,
  styleUrl: './mbm-avatar.component.scss',
})
export class MbmAvatarComponent {
  readonly name = input<string | null | undefined>('');
  readonly size = input<AvatarSize>('md');
  readonly tone = input<AvatarTone>('blue');

  protected readonly initials = computed(() => initialsOf(this.name()));
}
